import { createFileRoute } from '@tanstack/react-router';

import { PlacementsTable } from '../features/supply/placements/components/PlacementsTable';

export const Route = createFileRoute(
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements',
)({
  component: IntegrationPlacementsRoute,
});

function IntegrationPlacementsRoute() {
  const { integrationId } = Route.useParams();
  return <PlacementsTable demandIntegrationId={integrationId} showCreateAction={false} />;
}
